import { FC } from 'react'
import { CustomerContactsRoot } from 'CustomerContacts/index'
import { CustomerContextProvider } from 'Customer/hooks/useCustomerContext'
import { EditCustomerForm } from 'Customer/drawers/EditCustomer/EditCustomerForm'

type EditCustomerModalFormProps = {
  customerId: string
  onClose?: () => void
}

export const EditCustomerModalForm: FC<EditCustomerModalFormProps> = ({
  customerId,
  onClose: close
}) => {
  return (
    <CustomerContextProvider customerId={customerId}>
      <CustomerContactsRoot customerId={customerId}>
        <EditCustomerForm
          onSuccess={close}
          onClose={() => {
            close?.()
          }}
        />
      </CustomerContactsRoot>
    </CustomerContextProvider>
  )
}
